import React from 'react'
import styles from '../../styles/products.module.css';
import stylesC from '../../styles/common.module.css';
import { KR } from '../../constants/localizations';

export default function ProductDeliveryRobotBoxDetailAmr() {
    return (
        <>
            <div className={`${styles.robotDetails} ${stylesC.flex_col} ${styles.amrDetails}`}>
                <div className={styles.amrFlex}>
                    <div className={`${styles.robotDLeft} ${styles.amr}`}>
                        <div className={styles.flexBox}>
                            <span>{KR.label_products_detail_robot_size}</span>
                            <span >1,247(w)x1,890(d)x1,334(h)mm</span>
                        </div>
                        <div className={styles.flexBox}>
                            <span>{KR.label_products_detail_box_size}</span>
                            <span>1,080(w) x 1,540(d)</span>
                        </div>
                        <div className={styles.flexBox}>
                            <span>{KR.label_products_detail_max_quantity}</span>
                            <span>1t</span>
                        </div>
                    </div>
                    <div className={`${styles.robotDLeft} ${styles.amr}`}>
                        <div className={styles.flexBox}>
                            <span>{KR.label_products_detail_speed}</span>
                            <span>5km/h</span>
                        </div>
                        <div className={styles.flexBox}>
                            <span>{KR.label_products_detail_sensor}</span>
                            <span>2D 라이다·3D 라이다·카메라·초음파</span>
                        </div>
                    </div>
                </div>
                <div className={styles.badge}>
                    <div>원 프레임 구조 적용</div>
                    <div>기체 식별 LED 장착</div>
                    <div>비상정지 버튼</div>
                    <div>실외 험로 주행 구동 플랫폼</div>
                    <div>라이다&카메라 센서 퓨전</div>
                    <div>물품 적재 보관소</div>
                    <div>로봇 사용자 인터페이스</div>
                </div>
            </div >
        </>
    )
}
